import { Link } from "react-router-dom";
import { COLLECTIONS } from "@/config/collections";
import { ArrowRight } from "lucide-react";

export default function Collections() {
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-12 md:py-16">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">The Shop · Curated</p>
      <h1 className="font-serif text-5xl md:text-7xl tracking-tighter mt-2">Collections.</h1>
      <p className="mt-4 text-muted-foreground max-w-xl">
        Edits from the Spotters — ways to shop the marketplace without starting from scratch.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {COLLECTIONS.map((c) => (
          <Link key={c.slug} to={`/shop?collection=${c.slug}`} className="group relative aspect-[4/3] overflow-hidden bg-secondary">
            <img src={c.img} alt={c.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/85 via-foreground/25 to-transparent" />
            <div className="absolute inset-0 p-7 flex flex-col justify-end text-background">
              <h2 className="font-serif text-3xl md:text-4xl tracking-tighter">{c.title}</h2>
              <p className="mt-1 text-background/75 text-sm max-w-xs">{c.subtitle}</p>
              <span className="mt-3 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest">Shop this <ArrowRight size={14} /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
